var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-overlay",
        { attrs: { id: "container-material" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-card",
                  { attrs: { id: "Materiales" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "row col-12",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _c("h3", [_vm._v("Materiales")]),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-1 my-auto",
                            attrs: { hidden: "" }
                          },
                          [
                            _c("b-form-checkbox", {
                              attrs: { name: "check-button", switch: "" },
                              model: {
                                value: _vm.viewMaterials,
                                callback: function($$v) {
                                  _vm.viewMaterials = $$v
                                },
                                expression: "viewMaterials"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: { right: "1px", position: "absolute" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  pill: "",
                                  variant: "primary",
                                  size: "sm"
                                },
                                on: { click: _vm.addMaterial }
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "plus-circle-fill" }
                                }),
                                _vm._v(" Agregar Material ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c("PopUpAddMaterials", {
                      attrs: {
                        whoCall: _vm.whoCall,
                        arrayMaterial: _vm.arrayMaterial
                      },
                      on: { reload: _vm.searchListMaterial }
                    }),
                    _c(
                      "form",
                      {
                        attrs: {
                          autocomplete: "off",
                          "data-vv-scope": "search-material"
                        },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-4" },
                            [
                              _c("label", [
                                _vm._v("Buscar coincidencias Nombre Material")
                              ]),
                              _c(
                                "b-input-group",
                                [
                                  _c(
                                    "b-input-group-prepend",
                                    { attrs: { "is-text": "" } },
                                    [
                                      _c("b-icon", {
                                        staticStyle: { cursor: "pointer" },
                                        attrs: { icon: "search" },
                                        on: { click: _vm.searchListMaterial }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("b-form-input", {
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.searchListMaterial($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.textSearch,
                                      callback: function($$v) {
                                        _vm.textSearch = $$v
                                      },
                                      expression: "textSearch"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-md-3 " }, [
                            _c("label", [_vm._v("Categoría")]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.categoryMaterial,
                                    expression: "categoryMaterial"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "select" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.categoryMaterial = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c("option", {
                                  attrs: { selected: "" },
                                  domProps: { value: { value: 0, text: "" } }
                                }),
                                _vm._l(_vm.listCategorys, function(option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option.categoryId,
                                      domProps: {
                                        value: {
                                          value: option.categoryId,
                                          text: option.categoryName
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(option.categoryName) + " "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]),
                          _c("div", { staticClass: "col-md-3 " }, [
                            _c("label", [_vm._v("Marca")]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.brandMaterial,
                                    expression: "brandMaterial"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "select" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.brandMaterial = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c("option", {
                                  attrs: { selected: "" },
                                  domProps: { value: { value: 0, text: "" } }
                                }),
                                _vm._l(_vm.listBrands, function(option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option.brandId,
                                      domProps: {
                                        value: {
                                          value: option.brandId,
                                          text: option.brandName
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(option.brandName) + " "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-md-2 align-self-end" },
                            [
                              _c(
                                "vs-chip",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.searchListMaterial($event)
                                    }
                                  }
                                },
                                [
                                  _c("vs-avatar", {
                                    attrs: { icon: "search", color: "primary" }
                                  }),
                                  _c("strong", [_vm._v("Buscar")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "row col-12 mt-4" },
                      [
                        _c("b-table", {
                          ref: "tableMaterial",
                          staticClass: "w-100",
                          attrs: {
                            hover: "",
                            fields: _vm.fieldMat,
                            items: _vm.listMaterials
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "cell(categoryMaterial)",
                              fn: function(row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.item.categoryMaterial.descripcion
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(brandMaterial)",
                              fn: function(row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.item.brandMaterial.descripcion
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(priceMaterial)",
                              fn: function(row) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          parseInt(row.item.priceMaterial)
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(stateMaterial)",
                              fn: function(row) {
                                return [
                                  row.item.stateMaterial ===
                                  _vm.materialState.ACTIVE
                                    ? _c(
                                        "vs-chip",
                                        { attrs: { title: "Activo" } },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              icon: "thumb_up",
                                              color: "#26bd6a"
                                            }
                                          }),
                                          _vm._v(" Activo ")
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  row.item.stateMaterial ===
                                  _vm.materialState.INACTIVE
                                    ? _c(
                                        "vs-chip",
                                        { attrs: { title: "Inactivo" } },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              icon: "do_not_disturb",
                                              color: "#DB1D2A"
                                            }
                                          }),
                                          _vm._v(" Inactivo ")
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell(actions)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Desplegar acciones",
                                          expression: "'Desplegar acciones'"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "b-dropdown",
                                        {
                                          directives: [
                                            {
                                              name: "has-permission",
                                              rawName: "v-has-permission",
                                              value: "ED096",
                                              expression: "'ED096'"
                                            }
                                          ],
                                          attrs: {
                                            variant: "link",
                                            "no-caret": "",
                                            right: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "button-content",
                                                fn: function() {
                                                  return [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "align-middle text-body",
                                                      attrs: {
                                                        width: "24px",
                                                        height: "24px",
                                                        icon: "SettingsIcon"
                                                      }
                                                    })
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              attrs: { "data-cy": "edit-info" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editMaterial(
                                                    row.item.idMaterial,
                                                    _vm.materialState.ACTIVE
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("vs-icon", {
                                                attrs: { icon: "edit" }
                                              }),
                                              _vm._v(" Editar ")
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              attrs: {
                                                "data-cy": "edit-services"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showModalEditMaterialServices(
                                                    row.item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("vs-icon", {
                                                attrs: { icon: "content_paste" }
                                              }),
                                              _vm._v(" Servicios ")
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            [
                                              row.item.stateMaterial ===
                                              _vm.materialState.ACTIVE
                                                ? _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        "data-cy": "deactivate"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.chageStateMaterial(
                                                            row.item.idMaterial
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("vs-icon", {
                                                        attrs: { icon: "clear" }
                                                      }),
                                                      _vm._v(" Desactivar ")
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "b-dropdown-item",
                                                    {
                                                      attrs: {
                                                        "data-cy": "activate"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.chageStateMaterial(
                                                            row.item.idMaterial
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("vs-icon", {
                                                        attrs: { icon: "check" }
                                                      }),
                                                      _vm._v(" Activar ")
                                                    ],
                                                    1
                                                  )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("span")
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "row col-12" }, [
              _c("div", { staticClass: "col-lg-4" }, [
                _c("div", { staticClass: "mt-5" }, [
                  _vm._v(" Mostrando "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rowspp,
                          expression: "rowspp"
                        }
                      ],
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.rowspp = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.searchListMaterial()
                          }
                        ]
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { value: "10", selected: "selected" } },
                        [_vm._v("10")]
                      ),
                      _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                      _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                      _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
                    ]
                  ),
                  _vm._v(" registros por página. ")
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-lg-8" },
                [
                  _c("MaterialPagination", {
                    attrs: { show: _vm.listMaterials.length },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "b-modal",
            {
              ref: "material-edit-services",
              attrs: {
                size: "lg",
                "hide-footer": "",
                "no-close-on-backdrop": "",
                title:
                  "Editar servicios de material " +
                  _vm.selectedMaterial.nameMaterial
              }
            },
            [
              _c("materials-services-maintenance", {
                attrs: { material: _vm.selectedMaterial },
                on: { edited: _vm.handleOnServiceEdit }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }